import { WidgetType } from '../../../../shared/constants/widget';
import { WidgetDefinition } from '../../../../shared/types/widget';
import InsightsWidgetLoader from '../../../widgets/InsightsWidgetLoader';
import { WIDGET_TYPE_HEIGHT_MAP } from '../constants';

type Props = {
  widgetType: number;
  meta: WidgetDefinition;
};

export default function WidgetSuspenseFallback({ widgetType, meta }: Props) {
  return (
    <div
      className="flex flex-1 flex-col"
      style={{
        minHeight: WIDGET_TYPE_HEIGHT_MAP[widgetType as WidgetType] || 300,
      }}
    >
      <InsightsWidgetLoader showLoadingText={true} />
    </div>
  );
}
